

import React from "react";
import cookie from "react-cookies";
import Switch from "react-switch";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: cookie.load("token"),
      userRole: cookie.load("userRole"),
      userName: cookie.load("userName"),
      selectedProduct: cookie.load("activeProduct"),
      expiresAt: localStorage.getItem("expiresAt") || null,
      vasState: cookie.load("vasState"),
      daysLeft: null,
    };
    this.onChangeSelect = this.onChangeSelect.bind(this);
  }

  componentDidMount() {
    this.checkExpiry();
  }

  onChangeSelect(product) {
    if (product !== "logical") {
      this.setState({ selectedProduct: product });
      this.props.setActiveProduct(product);
      this.props.navigate("/");
    } else {
      window.open(
        `https://logical.topupbox.com?token=${this.state.token}`,
        "_blank",
        "noreferrer"
      );
    }
  }

  checkExpiry() {
    const { expiresAt } = this.state;
    if (!expiresAt) return; 

    const expiryDate = new Date(expiresAt);
    const now = new Date();

    if (isNaN(expiryDate.getTime())) {
      console.warn("Invalid expiresAt date:", expiresAt);
      return;
    }

    const diffMs = expiryDate - now;
    let diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));


    if (diffDays < 0) diffDays = 0;

    this.setState({ daysLeft: diffDays });
  }

  getBannerStyle() {
    const { daysLeft } = this.state;

    if (daysLeft === null || daysLeft > 60) {
      return { display: "none" };
    }

    if (daysLeft <= 3) {
      return {
        backgroundColor: "#FF4D4F",
        color: "#fff",
        padding: "8px",
        textAlign: "center",
        cursor: "pointer",
      };
    }

    return {
      backgroundColor: "#FFD966",
      color: "#000",
      padding: "8px",
      textAlign: "center",
      cursor: "pointer",
    };
  }

  renderBanner() {
    const { daysLeft } = this.state;

    if (daysLeft === null || daysLeft > 60) return null;

    return (
      <div
        style={this.getBannerStyle()}
        onClick={() => this.props.navigate("/profile")}
      >
        {daysLeft <= 3
          ? `⚠️ Your token will expire in ${daysLeft} day(s). Click here to refresh it.`
          : `🔔 Your token will expire in ${daysLeft} day(s). Click here to refresh it.`}
      </div>
    );
  }

  render() {
    return (
      <header className="top-header bg-white">
        {this.renderBanner()}
        <nav className="navbar navbar-expand gap-3 bg-white">
          <div className="mobile-toggle-icon fs-3">
            <i className="bi bi-list"></i>
          </div>
          <div>Dashboard</div>
          <div className="top-navbar-right ms-auto">
            <ul className="navbar-nav align-items-center">
              {/* Search */}
              <li className="nav-item search-toggle-icon">
                <a className="nav-link" href="#">
                  <div>
                    <i className="bi bi-search"></i>
                  </div>
                </a>
              </li>

              {/* Product Selector */}
              <li className="nav-item dropdown dropdown-large">
                <a
                  className="nav-link dropdown-toggle dropdown-toggle-nocaret"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <div>
                    <select
                      id="productSelect"
                      className="form-select"
                      value={this.props.activeProduct}
                      style={{
                        backgroundColor: "#E9EAEC50",
                        borderRadius: "48px",
                        fontWeight: "600",
                      }}
                      onChange={(event) =>
                        this.onChangeSelect(event.target.value)
                      }
                    >
                      <option value="enterprise">Enterprise</option>
                      <option value="logical">Logical</option>
                      <option value="unicard">Unicard</option>
                      <option value="mobileapp">Mobile App</option>
                      <option value="bills">Bills - VAS</option>
                      <option value="USSD">USSD (Coming Soon)</option>
                    </select>
                  </div>
                </a>
              </li>

              {/* User Dropdown */}
              <li className="nav-item dropdown dropdown-user-setting">
                <a
                  className="nav-link dropdown-toggle dropdown-toggle-nocaret"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <div className="user-setting d-flex align-items-center">
                    <img
                      src="assets/images/dummy.png"
                      className="user-img"
                      alt=""
                    />
                    <small className="px-3 mb-0 dropdown-user-designation">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: "14px",
                          fontWeight: "300",
                        }}
                      >
                        <div>{this.state.userName}</div>
                        <div style={{ fontWeight: "600" }}>
                          {this.state.userRole}
                        </div>
                      </div>
                    </small>
                  </div>
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="dropdown-item" href="/profile">
                      <i className="bi bi-person-fill"></i> Profile
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="/signIn">
                      <i className="bi bi-lock-fill"></i> Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }
}

export default Header;
